import { render } from "./TableFormsPublic.vue?vue&type=template&id=8ba7001e"
import script from "./TableFormsPublic.vue?vue&type=script&lang=js"
export * from "./TableFormsPublic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__